import {
  Button,
  DialogContent,
  DialogTitle,
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import RoundedTable from "@entrilia/shared/components/RoundedTable";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import WarningDialogIcon from "@entrilia/shared/icons/WarningDialogIcon";
import type { DeleteUserGroupResponseWorkflow } from "../../../../api/types/userManagementTypes";

interface Props {
  userGroupName: string;
  workflows: DeleteUserGroupResponseWorkflow[];
  onClose: () => void;
}

const UserGroupCannotBeDeletedDialog = ({ userGroupName, workflows, onClose }: Props) => (
  <SmallDialog open onClose={onClose}>
    <DialogTitle>Error</DialogTitle>
    <DialogCloseButton onClick={onClose} />

    <DialogContent>
      <Stack spacing={3} sx={{ alignItems: "center" }}>
        <WarningDialogIcon sx={{ width: 80, height: 80 }} />

        <Stack spacing={1} sx={{ alignItems: "center" }}>
          <Typography variant="h6">Can&apos;t delete {userGroupName}</Typography>
          <Typography color="textSecondary" sx={{ textAlign: "center" }}>
            The group cannot be deleted because it is used in active workflow approvals.
          </Typography>
        </Stack>

        {workflows.length > 0 && (
          <RoundedTable withoutColumnBorders paperProps={{ sx: { width: "100%" } }}>
            <TableHead>
              <TableRow>
                <TableCell>Company</TableCell>
                <TableCell>Workflow</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {workflows.map((workflow) => (
                <TableRow key={workflow.id}>
                  <TableCell>{workflow.clientName}</TableCell>
                  <TableCell>{workflow.name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </RoundedTable>
        )}
      </Stack>
    </DialogContent>

    <DialogButtons>
      <Button variant="contained" color="primary" onClick={onClose}>
        Close
      </Button>
    </DialogButtons>
  </SmallDialog>
);

export default UserGroupCannotBeDeletedDialog;
